import React, { forwardRef } from 'react';
import FocusLock from 'react-focus-lock';
import { UserMenuItem } from '../../menu-item';
import {
  PackageIcon,
  UserFocusIcon,
  IdentificationBadgeIcon,
  BriefcaseIcon,
  SignOutIcon,
} from '@fronton/icons-react';
import { patchUrlByLocale } from 'utils';
import { useTranslation } from 'react-i18next';
import { Divider } from 'fronton-react';
import { ContentClassName, OrganizationNameClassName } from './style';

const ORGANIZATIONS_URL = '/lkb2b/organization/';
const PROFILE_URL = '/lkb2b/personal-info/';

type ContentProps = {
  organizationName?: string;
  organizationCount: number;
  onLogout: () => void;
  showChangeOrganizationPopup: () => void;
};

export const Content = forwardRef<HTMLDivElement, ContentProps>((props, ref) => {
  const { t } = useTranslation();

  return (
    <div className={ContentClassName} ref={ref}>
      <FocusLock>
        <UserMenuItem icon={IdentificationBadgeIcon}>
          <span className={OrganizationNameClassName}>{props.organizationName || ''}</span>
        </UserMenuItem>
        <Divider />
        {props.organizationCount > 1 && (
          <UserMenuItem icon={BriefcaseIcon} href={patchUrlByLocale({ url: ORGANIZATIONS_URL })}>
            {t('header.main.b2b-user-menu.organizations')}
          </UserMenuItem>
        )}
        <UserMenuItem icon={PackageIcon} href={patchUrlByLocale({ url: PROFILE_URL })}>
          {t('header.main.b2b-user-menu.private')}
        </UserMenuItem>
        <Divider />
        {props.organizationCount > 1 && (
          <UserMenuItem icon={UserFocusIcon} onClick={props.showChangeOrganizationPopup}>
            {t('header.main.b2b-user-menu.change-organization')}
          </UserMenuItem>
        )}
        <UserMenuItem icon={SignOutIcon} onClick={props.onLogout}>
          {t('header.main.b2b-user-menu.exit')}
        </UserMenuItem>
      </FocusLock>
    </div>
  );
});
